<template>
  <div class="container">
    <h1>BIZTOSÍTÁSI SZERZŐDÉS ADATAI</h1>

    <div>
      <div class="row mb-3">
        <b>Kérjük, adja meg a biztosítandó társaság adószámát!</b>
      </div>
      <div class="row mb-3">
        <label class="col-sm-4" for="income">Adószám: </label>
        <div class="col-sm-4">
          <!-- <input class="form-control" :value="phtax" /> -->
          <ValidationProvider
            rules="adoszam"
            v-slot="{ errors, classes }"
            class="col-md-4 mb-3"
          >
            <input
              v-maska="'########-#-##'"
              type="text"
              class="form-control"
              id="adoszam"
              name="adoszam"
              v-model="phtax"
              aria-label="Adószám"
              aria-describedby="adoszam-prepend"
              :class="classes"
            />
            <small id="adoszam-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
        </div>
        <div class="col-2">
          <button
            class="btn btn-red w-100 d-flex align-items-center justify-content-center"
            @click.prevent="searchTaxNumber()"
            :disabled="!correctedTaxNumberLength"
          >
            Keresés
          </button>
        </div>
      </div>
      <div class="form-group">
        <div class="row">
          <ValidationProvider
            v-show="false"
            :immediate="true"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="input-group">
              <label class="col-2" for="ph_tax">Adószám: </label>
              <input
                class="form-control col-2"
                id="ph_tax"
                name="ph_tax"
                v-model="displayedTaxNumber"
              />
              <small class="text-danger input-alert">{{ errors[0] }}</small>
            </div>
          </ValidationProvider>
        </div>
        <div class="text-center text-danger input-alert" v-if="true">
          {{ optenErrorMessge }}
        </div>
        <div v-show="false" class="form-group row mb-3">
          <label class="col-sm-4" for="ph_profitaftertax"
            >Adózott eredmény:
          </label>
          <div class="col-sm-4">
            <input
              class="form-control"
              id="ph_profitaftertax"
              name="ph_profitaftertax"
              :value="profitaftertax"
              readonly
            />
          </div>
        </div>

        <div v-show="false" class="form-group row mb-3">
          <label class="col-sm-4" for="opten_companyok">opten_companyok </label>
          <div class="col-sm-4">
            <input
              class="form-control"
              id="opten_companyok"
              name="opten_companyok"
              :value="optenCompnayOk"
              readonly
            />
          </div>
        </div>
        <div v-show="false" class="form-group row mb-3">
          <label class="col-sm-4" for="opten_financeok">opten_companyok </label>
          <div class="col-sm-4">
            <input
              class="form-control"
              id="opten_financeok"
              name="opten_financeok"
              :value="optenFinanceOk"
              readonly
            />
          </div>
        </div>
        <div v-show="false" class="form-group row mb-3">
          <label class="col-sm-4" for="ph_companystate">company stat </label>
          <div class="col-sm-4">
            <input
              class="form-control"
              id="ph_companystate"
              name="ph_companystate"
              :value="companystatuscode"
              readonly
            />
          </div>
        </div>
        <h1 class="h2 mt-4">Szerződő adatai</h1>
        <div class="form-group row mb-3">
          <div v-if="this.taxnumInvalidAfterSearch">
            <h2 class="h3 d-flex justify-content-center align-items-cente">
              Kérjük, adja meg a Cégadatokat!
            </h2>
          </div>
          <label class="col-sm-4" for="ph_companyname">Cég neve: </label>
          <div class="col">
            <ValidationProvider
              rules="required"
              v-slot="{ errors, classes }"
              class="col-md-6 mb-3"
            >
              <input
                class="form-control"
                id="ph_companyname"
                name="ph_companyname"
                v-model="companyname"
                :readonly="!taxnumInvalidAfterSearch"
                :class="classes"
              />
              <small id="kozterulet-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="ph_registrationdate"
            >Bejegyzés dátuma:
          </label>
          <div class="col-sm-4">
            <input
              class="form-control"
              id="ph_registrationdate"
              name="ph_registrationdate"
              :value="registrationdate"
              :readonly="!taxnumInvalidAfterSearch"
            />
          </div>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4"
            >Cég adószáma:<span class="text-danger">*</span>
          </label>
          <div class="col-sm-4">
            <ValidationProvider
              rules="adoszam"
              v-slot="{ errors, classes }"
              class="col-md-4 mb-3"
            >
              <input
                v-maska="'########-#-##'"
                class="form-control"
                v-model="displayedTaxNumber"
                :readonly="!taxnumInvalidAfterSearch"
                :class="classes"
              />
              <small id="adoszam-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
          </div>
        </div>
        <div>
          <label class="col-sm-4 mb-3">Cég székhelye:</label>
          <div class="row">
            <div class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="kockazat_irsz-prepend"
                    >Irányítószám: <span class="text-danger">*</span></span
                  >
                </div>
                <!-- <input
                  type="number"
                  class="form-control"
                  id="ph_zip"
                  name="ph_zip"
                  readonly
                  :value="zip"
                  aria-label="Irányítószám"
                  aria-describedby="kockazat_irsz-prepend"
                /> -->
                <ValidationProvider
                  :immediate="true"
                  rules="valid_zip"
                  v-slot="{ errors }"
                  class="col-md-6 mb-3"
                >
                  <Select2
                    id="ph_zip"
                    name="ph_zip"
                    v-model="zip"
                    :options="zipCodes"
                    aria-label="Irányítószám"
                    aria-describedby="kockazat_irsz-prepend"
                    class="form-control px-1"
                    :settings="{ selectionCssClass: 'w-full' }"
                    :disabled="optenLoading"
                  />
                  <small id="ph_zip-error" class="text-danger input-alert">{{
                    errors[0]
                  }}</small>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="kockazat_telepules-prepend"
                    >Település neve: <span class="text-danger">*</span></span
                  >
                </div>
                <!-- <input
                  type="text"
                  class="form-control"
                  id="ph_city"
                  name="ph_city"
                  disabled
                  :value="city"
                  aria-label="Település neve"
                  aria-describedby="kockazat_telepules-prepend"
                  readonly
                /> -->
                <Select2
                  name="ph_city"
                  v-model="city"
                  :options="cityNames"
                  class="form-control px-1"
                  :settings="{ selectionCssClass: 'w-full' }"
                  v-if="cityNames.length > 1"
                  :disabled="optenLoading"
                />
                <input
                  v-else
                  type="text"
                  class="form-control mb-2"
                  readonly
                  name="ph_city"
                  :value="city"
                />
              </div>
            </div>
            <!-- <ValidationProvider rules="valid_zip" v-slot="{errors}" class="col-md-6 mb-3">
              <input v-model="zip" v-show="true" />
              <small id="valid_zip-error" class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider> -->
          </div>
          <div class="row">
            <ValidationProvider
              rules=""
              v-slot="{ errors, classes }"
              class="col-md-6 mb-3"
            >
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="kozterulet-prepend"
                    >Közterület neve: <span class="text-danger">*</span></span
                  >
                </div>
                <input
                  type="text"
                  class="form-control"
                  id="ph_add_streetname"
                  name="ph_add_streetname"
                  v-model="streetname"
                  aria-label="Közterület neve"
                  aria-describedby="kozterulet-prepend"
                  :class="classes"
                  :disabled="optenLoading"
                />
              </div>
              <small id="kozterulet-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
            <ValidationProvider
              rules=""
              v-slot="{ errors, classes }"
              class="col-md-6 mb-3"
            >
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="ph_add_streettype-prepend"
                    >Közterület jellege:
                    <span class="text-danger">*</span></span
                  >
                </div>
                <input
                  type="text"
                  class="form-control"
                  id="ph_add_streettype"
                  name="ph_add_streettype"
                  v-model="streettype"
                  aria-label="Közterület jellege"
                  aria-describedby="ph_add_streettype-prepend"
                  :class="classes"
                  :disabled="optenLoading"
                />
              </div>
              <small
                id="ph_add_streettype-error"
                class="text-danger input-alert"
                >{{ errors[0] }}</small
              >
            </ValidationProvider>
          </div>
          <div class="row">
            <ValidationProvider
              rules=""
              v-slot="{ errors, classes }"
              class="col-md-6 mb-3"
            >
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="ph_add_streetno-prepend"
                    >Házszám:</span
                  >
                </div>
                <input
                  type="text"
                  class="form-control"
                  id="ph_add_streetno"
                  name="ph_add_streetno"
                  v-model="streetno"
                  aria-label="Házszám"
                  aria-describedby="ph_add_streetno-prepend"
                  :class="classes"
                  :disabled="optenLoading"
                />
              </div>
              <small
                id="ph_add_streetno-error"
                class="text-danger input-alert"
                >{{ errors[0] }}</small
              >
            </ValidationProvider>
            <!-- <div class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="kockazat_epl-prepend"
                    >Épület, emelet, ajtó:</span
                  >
                </div>
                <input
                  type="text"
                  class="form-control"
                  id="kockazat_epl"
                  name="kockazat_epl"
                  v-model="streetother"
                  aria-label="Épület, emelet, ajtó"
                  aria-describedby="kockazat_epl-prepend"
                  readonly
                />
              </div>
              <small id="kockazat_epl-error" class="text-danger input-alert"></small>
            </div> -->
          </div>
          <!-- <div class="row">
            <ValidationProvider rules="" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="ph_hrsz-prepend">Helyrajzi szám: </span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  id="ph_hrsz"
                  name="ph_hrsz"
                  v-model="hrsz"
                  aria-label="Házszám"
                  aria-describedby="ph_hrsz-prepend"
                  :class="classes"
                  :disabled="optenLoading"
                />
              </div>
              <small id="ph_hrsz-error" class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div> -->
        </div>
        <!-- <h1 class="h2 mt-4">Cég Pénzügyi adatai</h1> -->
        <ValidationProvider
          rules="required"
          v-slot="{ errors }"
          class="form-group row mb-3"
        >
          <label class="col-sm-4" for="income"
            >Értékesítés nettó árbevétele:
            <span class="text-danger">*</span></label
          >
          <div class="col-sm-4">
            <div class="input-group mb-3">
              <input
                class="form-control"
                v-model="net_income"
                v-number="netIncomeFormatting"
                aria-describedby="currency-addon"
              />
              <span class="input-group-text" id="currency-addon">Ft</span>
            </div>
            <small id="ph_net_income-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </div>
        </ValidationProvider>
        <div v-if="!taxnumInvalidAfterSearch">
          <div class="form-group row mb-3">
            <label class="col-sm-4" for="ph_companytypename">Cégforma: </label>
            <div class="col-sm-4">
              <input
                class="form-control"
                id="ph_companytypename"
                name="ph_companytypename"
                v-model="companytypename"
              />
            </div>
          </div>
          <div v-show="false" class="form-group row mb-3">
            <label class="col-sm-4" for="ph_companytype">Cégforma kód: </label>
            <div class="col-sm-4">
              <input
                class="form-control"
                id="ph_companytype"
                name="ph_companytype"
                :value="GFO[chosenGFO]"
                readonly
              />
            </div>
          </div>
        </div>
        <div v-else>
          <div class="form-group row my-3">
            <label class="col-sm-4" for="selected_limit"
              >Kérjük, válassza ki a cégformát:<span class="text-danger"
                >*</span
              >
            </label>
            <div class="col-sm-4">
              <div>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  class="col-md-6 mb-3"
                >
                  <select
                    class="form-select"
                    id="custom_gfo_code"
                    name="custom_gfo_code"
                    v-model="chosenGFO"
                    required
                  >
                    <option value="" selected disabled
                      >Kérem, válasszon!</option
                    >
                    <option
                      v-for="(value, key) in gfoNames"
                      :key="key"
                      :value="key"
                      >{{ value }}</option
                    >
                  </select>
                  <small id="limit-error" class="text-danger input-alert">{{
                    errors[0]
                  }}</small>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div v-show="false" class="form-group row mb-3">
            <label class="col-sm-4" for="ph_companytype">Cégforma kód: </label>
            <div class="col-sm-4">
              <input
                class="form-control"
                id="ph_companytype"
                name="ph_companytype"
                :value="GFO[chosenGFO]"
                readonly
              />
            </div>
          </div>
        </div>
        <div v-show="false">
          <label class="col-sm-4 mb-3">Cég pénzügyi adatai:</label>
          <div class="form-group row mb-3">
            <label class="col-sm-4" for="ph_companytypename">Cégforma: </label>
            <div class="col-sm-4">
              <input
                class="form-control"
                id="ph_companytypename"
                name="ph_companytypename"
                :value="companytypename"
                readonly
              />
            </div>
          </div>
          <div v-show="false" class="form-group row mb-3">
            <label class="col-sm-4" for="ph_net_income"
              >Értékesítés nettó árbevétele:
            </label>
            <div class="col-sm-4">
              <input
                class="form-control"
                id="ph_net_income"
                name="ph_net_income"
                :value="net_income"
                readonly
              />
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-sm-4" for="income"
              >Értékesítés nettó árbevétele:
            </label>
            <div v-if="!financialdatamanualy" class="col-sm-4">
              <input
                class="form-control"
                :value="net_income | currency"
                readonly
              />
            </div>
            <div v-else class="col-sm-4">
              <input class="form-control" v-model="net_income" type="number" />
            </div>
          </div>
          <div v-show="false" class="form-group row mb-3">
            <label class="col-sm-4" for="ph_profitaftertax"
              >Adózott eredmény:
            </label>
            <div class="col-sm-4">
              <input
                class="form-control"
                id="ph_profitaftertax"
                name="ph_profitaftertax"
                :value="profitaftertax"
              />
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-sm-4" for="profitaftertax"
              >Adózott eredmény:
            </label>
            <div v-if="!financialdatamanualy" class="col-sm-4">
              <input
                class="form-control"
                :value="profitaftertax | currency"
                readonly
              />
            </div>
            <div v-else class="col-sm-4">
              <input
                class="form-control"
                v-model="profitaftertax"
                type="number"
              />
            </div>
          </div>
          <div v-show="false" class="form-group row mb-3">
            <label class="col-sm-4" for="ph_totalassets"
              >Eszközök összesen:
            </label>
            <div class="col-sm-4">
              <input
                class="form-control"
                id="ph_totalassets"
                name="ph_totalassets"
                v-model="totalassets"
              />
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-sm-4" for="totalassets"
              >Eszközök összesen:
            </label>
            <div class="col-sm-4">
              <input
                v-if="!financialdatamanualy"
                class="form-control"
                :value="totalassets | currency"
                readonly
              />
              <input
                v-else
                class="form-control"
                v-model="totalassets"
                type="number"
              />
            </div>
          </div>
          <div v-show="false" class="form-group row mb-3">
            <label class="col-sm-4" for="ph_equity">Saját tőke: </label>
            <div class="col-sm-4">
              <input
                class="form-control"
                id="ph_equity"
                name="ph_equity"
                :value="equity"
                readonly
              />
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-sm-4" for="equity">Saját tőke: </label>
            <div v-if="!financialdatamanualy" class="col-sm-4">
              <input class="form-control" :value="equity | currency" readonly />
            </div>
            <div v-else class="col-sm-4">
              <input class="form-control" v-model="equity" type="number" />
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-sm-4" for="ph_yearofdata"
              >Pénzügyi adatok éve:
            </label>
            <div v-if="!financialdatamanualy" class="col-sm-4">
              <input
                class="form-control"
                id="ph_yearofdata"
                name="ph_yearofdata"
                :value="yearofdata"
                readonly
              />
            </div>
            <div v-else class="col-sm-4">
              <input
                class="form-control"
                id="ph_yearofdata"
                name="ph_yearofdata"
                v-model="yearofdata"
                type="number"
              />
            </div>
          </div>
          <div v-if="process === 'EGYEDI'">
            <b>
              {{ marks.msg_egyedi }}
            </b>
          </div>
        </div>
        <div
          v-show="false"
          v-if="financialdatamanualy && optenCompnayOk"
          class="col-2"
        >
          <button
            class="btn btn-red w-100 d-flex align-items-center justify-content-center"
            @click.prevent="getLimits"
            :disabled="!correctedTaxNumberLength"
          >
            Limitek igénylése
          </button>
        </div>
        <!-- <div class="form-check mb-4">
          <label for="limit_type" class="form-check-label">
            <b
              >Dupla limit opciót kérek:
              <span
                class="info"
                id="duplalimit-tooltip"
                data-toggle="tooltip"
                data-placement="right"
                title=""
              >
                ?</span
              ></b
            >
          </label>
          <input
            type="checkbox"
            class="form-check-input"
            id="biztositasi_feltetelek"
            name="limit_type"
            :value="limitType"
            v-model="limitType"
          />
        </div> -->
        <!-- EZ KELL KELLHET MÉG -->
        <div>
          <!-- <div class="form-group row mb-3">
            <label class="col-sm-4" for="turnover_band"
              >Kérjük adja meg a Biztosított nettó árbevételét!:<span class="text-danger">*</span>
            </label>
            <div class="col-sm-4">
              <div>
                <ValidationProvider rules="required" v-slot="{errors}" class="col-md-6 mb-3">
                  <select
                    class="form-select"
                    id="turnover_band"
                    name="turnover_band"
                    v-model="chosenTurnover"
                    required
                  >
                    <option value="" selected disabled>Kérem, válasszon!</option>
                    <option v-for="(value, key) in turnover_band" :key="key" :value="key">{{
                      value
                    }}</option>
                  </select>
                  <small id="ph_contact_lastname-error" class="text-danger input-alert">{{
                    errors[0]
                  }}</small>
                </ValidationProvider>
              </div>
            </div>
          </div> -->
        </div>
        <div>
          <div v-if="chosenTurnover !== 't7'" class="form-group row mb-3">
            <label class="col-sm-4" for="selected_limit"
              >Kérjük, válassza ki a limitet:<span class="text-danger">*</span>
            </label>
            <div class="col-sm-4">
              <div>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  class="col-md-6 mb-3"
                >
                  <select
                    class="form-select"
                    id="selected_limit"
                    name="selected_limit"
                    v-model="chosenLimit"
                    required
                  >
                    <option value="" selected disabled
                      >Kérem, válasszon!</option
                    >
                    <option
                      v-for="(value, key) in limittomb"
                      :key="key"
                      :value="key"
                      >{{ value.name }}</option
                    >
                  </select>
                  <small
                    id="ph_contact_lastname-error"
                    class="text-danger input-alert"
                    >{{ errors[0] }}</small
                  >
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>
        <!-- EDDIG -->
        <div v-show="false" class="form-check mb-4">
          <input
            type="text"
            class="form-check-input"
            id="double_limit"
            name="double_limit"
            v-model="double_limit"
          />
        </div>

        <!-- <div v-if="limittomb">
          <div>
            <select
              class="form-select"
              id="selected_limit"
              name="selected_limit"
              v-model="chosenLimit"
              required
            >
              <option value="" selected disabled>Kérem, válasszon!</option>
              <option v-for="(value, key) in limittomb" :key="key" :value="key">{{
                value.name
              }}</option>
            </select>
          </div>
         
        </div>
        <div v-else>
          kérjük várjon
        </div> -->
        <!-- <OverallData></OverallData> -->
        <info-text></info-text>
        <div class="form-group row mb-3">
          <div v-if="merchant_id !== 'colo213'">
            <h1 class="h2 mt-4">Biztosításközvetítő adatai</h1>
            <div class="form-group row mb-3">
              <label class="col-sm-4" for="brokernev"
                >Biztosításközvetítő neve:
              </label>
              <div class="col">
                <input
                  class="form-control"
                  id="brokernev"
                  name="brokernev"
                  :value="brokernev"
                  readonly
                />
              </div>
            </div>
            <div class="form-group row mb-3">
              <label class="col-sm-4" for="merchant_email"
                >Biztosításközvetítő e-mail címe:
                <span class="text-danger">*</span></label
              >
              <div class="col">
                <ValidationProvider
                  :rules="{ required: true, email: true }"
                  v-slot="{ errors }"
                  class="col-md-6 mb-3"
                >
                  <input
                    class="form-control"
                    id="merchant_email"
                    name="merchant_email"
                    v-model="brokeremail"
                    :readonly="merchant_id === 'eurosales'"
                  />
                  <small
                    id="merchant_email-error"
                    class="text-danger input-alert"
                    >{{ errors[0] }}</small
                  >
                </ValidationProvider>
              </div>
            </div>
            <div class="form-group row mb-3">
              <label for="ph_email" class="col-sm-4"
                >Ügyfél e-mail címe: <span class="text-danger">*</span></label
              >
              <ValidationProvider
                :rules="{ required: true, email: true }"
                v-slot="{ errors, classes }"
                class="col-sm-8"
              >
                <input
                  type="email"
                  class="form-control"
                  id="ph_email"
                  name="ph_email"
                  v-model="insuredEmail"
                  :class="classes"
                />
                <small id="ph_email-error" class="text-danger input-alert">{{
                  errors[0]
                }}</small>
              </ValidationProvider>
            </div>
            <div>
              <div
                v-if="ertekesito_koti && !customer_link_reloaded"
                class="form-group row my-3"
              >
                <label class="col-sm-4" for="send_validationemail_to"
                  >Kinek Küldjük a validációs emailt?:<span class="text-danger"
                    >*</span
                  >
                </label>
                <div class="col-sm-4">
                  <div>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      class="col-md-6 mb-3"
                    >
                      <select
                        class="form-select"
                        id="send_validationemail_to"
                        name="send_validationemail_to"
                        v-model="send_validationemail_to"
                        required
                      >
                        <option value="" selected disabled
                          >Kérem, válasszon!</option
                        >
                        <option value="client">Ügyfél</option>
                        <option value="broker">Bróker</option>
                        <option value="both">Mind a kettő</option>
                      </select>
                      <small id="limit-error" class="text-danger input-alert">{{
                        errors[0]
                      }}</small>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="form-group row mb-3">
              <label class="col-sm-4" for="merchant_phone">Biztosításközvetítő Telefonszám: </label>
              <div class="col">
                <input
                  class="form-control"
                  id="merchant_phone"
                  name="merchant_phone"
                  v-model="brokertel"
                  :disabled="merchant_id === 'eurosales'"
                />
              </div>
            </div> -->
            <!-- <div class="form-group row mb-3">
              <label class="col-sm-4" for="brokercim">Biztostásközvetítő Cím: </label>
              <div class="col">
                <input
                  class="form-control"
                  id="brokercim"
                  name="brokercim"
                  :value="brokercim"
                  readonly
                />
              </div>
            </div> -->
          </div>
          <div v-if="merchant_id === 'colo213' || merchant_id === 'eurosales'">
            <h1 class="h2 mt-4">Szerződő/kapcsolattartó adatai</h1>
            <div>
              <div class="row">
                <ValidationProvider
                  v-slot="{ errors, classes }"
                  class="col-md-6 mb-3"
                >
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span
                        class="input-group-text"
                        id="ph_contact_lastname_prepend"
                        >Vezetéknév:
                      </span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="ph_contact_lastname"
                      name="ph_contact_lastname"
                      v-model="insuredLastName"
                      aria-label="Vezetéknév"
                      aria-describedby="ph_contact_lastname_prepend"
                      :class="classes"
                    />
                  </div>
                  <small
                    id="ph_contact_lastname-error"
                    class="text-danger input-alert"
                    >{{ errors[0] }}</small
                  >
                </ValidationProvider>
                <ValidationProvider
                  v-slot="{ errors, classes }"
                  class="col-md-6 mb-3"
                >
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span
                        class="input-group-text"
                        id="ph_contact_firstname_prepend"
                        >Keresztnév:</span
                      >
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="ph_contact_firstname"
                      name="ph_contact_firstname"
                      v-model="insuredFirstName"
                      aria-label="Keresztnév"
                      aria-describedby="ph_contact_firstname_prepend"
                      :class="classes"
                    />
                  </div>
                  <small
                    id="ph_contact_firstname-error"
                    class="text-danger input-alert"
                    >{{ errors[0] }}</small
                  >
                </ValidationProvider>
              </div>
            </div>
            <div class="form-group row mb-3">
              <label for="ph_email" class="col-sm-4"
                >E-mail cím: <span class="text-danger">*</span></label
              >
              <ValidationProvider
                :rules="{ required: true, email: true }"
                v-slot="{ errors, classes }"
                class="col-sm-8"
              >
                <input
                  type="email"
                  class="form-control"
                  id="ph_email"
                  name="ph_email"
                  v-model="insuredEmail"
                  :class="classes"
                />
                <small id="ph_email-error" class="text-danger input-alert">{{
                  errors[0]
                }}</small>
              </ValidationProvider>
            </div>
            <!-- <div class="form-group row">
              <label class="col-sm-4" for="biztositott_telefonszam">Telefonszáma:</label>
              <ValidationProvider rules="max:2" v-slot="{errors, classes}" class="col-sm-3 mb-3">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="ph_phone_pre_prepend">+36</span>
                  </div>
                  <input
                    type="number"
                    min="1"
                    max="99"
                    class="form-control"
                    id="ph_phone_pre"
                    name="ph_phone_pre"
                    aria-label="Körzetszám"
                    aria-describedby="ph_phone_pre_prepend"
                    v-model.number="PhoneNumberArea"
                    :class="classes"
                  />
                </div>
                <small id="ph_phone_pre-error" class="text-danger input-alert">{{
                  errors[0]
                }}</small>
              </ValidationProvider>
              <ValidationProvider rules="min:6|max:7" v-slot="{errors, classes}" class="col-sm-5">
                <input
                  type="number"
                  class="form-control"
                  id="ph_phone"
                  name="ph_phone"
                  v-model="PhoneNumber"
                  :class="classes"
                />
                <small id="ph_phone-error" class="text-danger input-alert">{{ errors[0] }}</small>
              </ValidationProvider>
            </div> -->
            <div v-show="false">
              <select
                class="form-select"
                id="send_validationemail_to"
                name="send_validationemail_to"
                required
              >
                <option value="client" selected>Ügyfél</option>
              </select>
            </div>
            <div v-show="false">
              <select
                v-if="customer_link_reloaded"
                class="form-select"
                id="send_validationemail_to"
                name="send_validationemail_to"
                required
              >
                <option value="client" selected>Ügyfél</option>
              </select>
            </div>
          </div>
          <div v-if="false">
            <h1 class="h2 mt-4">Biztosításközvetítő adatai</h1>
            <div>
              <div class="row">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, classes }"
                  class="col-md-6 mb-3"
                >
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="ins_lastname_prepend"
                        >Vezetéknév: <span class="text-danger">*</span></span
                      >
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="ins_lastname"
                      name="ins_lastname"
                      v-model="insuredLastName"
                      aria-label="Vezetéknév"
                      aria-describedby="ins_lastname_prepend"
                      :class="classes"
                    />
                  </div>
                  <small
                    id="ins_lastname-error"
                    class="text-danger input-alert"
                    >{{ errors[0] }}</small
                  >
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, classes }"
                  class="col-md-6 mb-3"
                >
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="ins_firstname_prepend"
                        >Keresztnév: <span class="text-danger">*</span></span
                      >
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="ins_firstname"
                      name="ins_firstname"
                      v-model="insuredFirstName"
                      aria-label="Keresztnév"
                      aria-describedby="ins_firstname_prepend"
                      :class="classes"
                    />
                  </div>
                  <small
                    id="ins_firstname-error"
                    class="text-danger input-alert"
                    >{{ errors[0] }}</small
                  >
                </ValidationProvider>
              </div>
            </div>
            <div class="form-group row mb-3">
              <label for="ins_email" class="col-sm-4"
                >E-mail cím: <span class="text-danger">*</span></label
              >
              <ValidationProvider
                :rules="{ required: true, email: true }"
                v-slot="{ errors, classes }"
                class="col-sm-8"
              >
                <input
                  type="email"
                  class="form-control"
                  id="ins_email"
                  name="ins_email"
                  v-model="insuredEmail"
                  :class="classes"
                />
                <small id="ins_email-error" class="text-danger input-alert">{{
                  errors[0]
                }}</small>
              </ValidationProvider>
            </div>
            <div class="form-group row mb-3">
              <label for="ins_email_2" class="col-sm-4"
                >E-mail cím ismételt megadása:
                <span class="text-danger" v-if="insuredEmail != ''"
                  >*</span
                ></label
              >
              <ValidationProvider
                :rules="{
                  required_if: 'ins_email',
                  email: true,
                  is: insuredEmailVerification,
                }"
                v-slot="{ errors, classes }"
                class="col-sm-8"
              >
                <input
                  type="email"
                  class="form-control"
                  id="ins_email_2"
                  name="ins_email_2"
                  v-model="insuredEmailVerification"
                  :class="classes"
                />
                <small id="ins_email_2-error" class="text-danger input-alert">{{
                  errors[0]
                }}</small>
              </ValidationProvider>
            </div>
            <div class="form-group row">
              <label class="col-sm-4" for="biztositott_telefonszam"
                >Telefonszáma: <span class="text-danger">*</span></label
              >
              <ValidationProvider
                rules="required|max:2"
                v-slot="{ errors, classes }"
                class="col-sm-3 mb-3"
              >
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="ins_phone_pre_prepend"
                      >+36</span
                    >
                  </div>
                  <input
                    type="number"
                    min="1"
                    max="99"
                    class="form-control"
                    id="ins_phone_pre"
                    name="ins_phone_pre"
                    aria-label="Körzetszám"
                    aria-describedby="ins_phone_pre_prepend"
                    v-model.number="PhoneNumberArea"
                    :class="classes"
                  />
                </div>
                <small
                  id="ins_phone_pre-error"
                  class="text-danger input-alert"
                  >{{ errors[0] }}</small
                >
              </ValidationProvider>
              <ValidationProvider
                rules="required|min:6|max:7"
                v-slot="{ errors, classes }"
                class="col-sm-5"
              >
                <input
                  type="number"
                  class="form-control"
                  id="ins_phone"
                  name="ins_phone"
                  v-model="phoneNumber"
                  :class="classes"
                />
                <small id="ins_phone-error" class="text-danger input-alert">{{
                  errors[0]
                }}</small>
              </ValidationProvider>
            </div>
          </div>
          <!-- <h1 class="h2 mt-4">Díjfizetés</h1>
          <div class="form-group row mb-3">
            <div class="col-sm-4">
              <b
                >Díjfizetési mód <span class="text-danger">*</span>
                <span
                  class="info"
                  id="payment_way-tooltip"
                  data-toggle="tooltip"
                  data-placement="right"
                  title=""
                  >?</span
                ></b
              >
            </div>
            <div class="col-sm-8 row">
              <input type="text" hidden v-model="paymentType" name="payment_way" />
              <div class="col-md-4 form-group mb-2">
                <div
                  class="btn w-100 h-100 d-flex align-items-center justify-content-center"
                  @click="paymentType = 'banktransfer'"
                  :class="{
                    'btn-red': paymentType == 'banktransfer',
                    'btn-outline-danger': paymentType !== 'banktransfer',
                  }"
                >
                  Banki átutalás
                </div>
              </div>
            </div>
            <small id="payment_way-error" class="text-danger input-alert"></small>
          </div>
          <div class="form-group row mb-3">
            <div class="col-sm-4">
              <b
                >Díjfizetési gyakoriság
                <span class="text-danger">*</span>
                <span
                  class="info"
                  id="payment_frequency-tooltip"
                  data-toggle="tooltip"
                  data-placement="right"
                  title=""
                  >?</span
                ></b
              >
            </div>
            <div class="col-sm-8 row">
              <input type="text" hidden v-model="paymentFrequency" name="payment_frequency" />
              <div class="col-md-4 form-group mb-2">
                <div
                  class="btn w-100 h-100 d-flex align-items-center justify-content-center"
                  @click="paymentFrequency = 'yearly'"
                  :class="{
                    'btn-red': paymentFrequency == 'yearly',
                    'btn-outline-danger': paymentFrequency !== 'yearly',
                  }"
                >
                  Éves
                </div>
              </div>
            </div>
            <small id="payment_frequency-error" class="text-danger input-alert"></small>
          </div> -->
          <!-- <div class="form-group row">
            <label class="col-sm-4" for="begin_date"
              >Kockázatviselés kezdete: <span class="text-danger">*</span></label
            >
            <div class="col-sm-8">
              <Datepicker
                id="begin_date"
                name="begin_date"
                :format="'yyyy-MM-dd'"
                :placeholder="'ÉÉÉÉ-HH-NN'"
                :language="hu"
                :disabled-dates="riskStartDisabledDates"
                :typeable="false"
                input-class="form-control"
                required
                v-model="startDate"
              ></Datepicker>
              <ValidationProvider
                :immediate="true"
                rules="required|kockazat_kezdet"
                v-slot="{errors}"
              >
                <input type="text" name="begin_date" :value="startDate" disabled hidden />
                <small class="text-danger input-alert">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
          </div> -->
        </div>
        <div v-if="process === 'EGYEDI'">
          <b>
            {{ marks.msg_egyedi }}
          </b>
        </div>
        <!-- <div v-else>nincs</div> -->
        <!-- <div class="row">
          <div class="col-sm-4">
            <div class="row">
              <div class="col-md-4">
                <ValidationProvider :immediate="true" rules="required" v-slot="{errors}">
                  <div class="input-group">
                    <label class="col-sm-4" for="agent_id">Adóazonosító: </label>
                    <input class="form-control" id="agent_id" name="agent_id" v-model="agentId" />
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import SideBuilding from "./components/SideBuilding";
import Select2 from "v-select2-component";
import Datepicker from "vuejs-datepicker";
import { hu } from "vuejs-datepicker/dist/locale";
import OverallData from "./components/OverallData";
import { debounce } from "debounce";
import { type } from "jquery";
import { faMarsStroke } from "@fortawesome/free-solid-svg-icons";
import InfoText from "./components/infotext.vue";
import { directive as VNumber } from "@coders-tm/vue-number-format";
import SIDCode from "./components/SIDCode.vue";
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    SideBuilding,
    Select2,
    Datepicker,
    OverallData,
    InfoText,
    SIDCode,
  },
  data() {
    const now = new Date();
    const today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - 1,
    );
    const minDate = new Date();
    minDate.setFullYear(today.getFullYear() - 80);
    minDate.setMonth(1);
    minDate.setDate(1);
    const maxDateIns = new Date();
    maxDateIns.setFullYear(today.getFullYear() - 12);
    maxDateIns.setMonth(now.getMonth());
    maxDateIns.setDate(now.getDate());
    const maxDate = new Date();
    maxDate.setFullYear(today.getFullYear() - 18);
    maxDate.setMonth(now.getMonth());
    maxDate.setDate(now.getDate());

    return {
      hu: hu,
      cityNames: [],
      summaryPrice: 0,
      clickedMainBuildingPrice: false,
      clickedSideBuildingPrice: false,
      clickedAllGoodsPrice: false,
      bornInitialDate: maxDateIns,
      bornDisabledDates: {
        customPredictor: function(date) {
          return date > maxDateIns || date < minDate;
        },
      },
      riskStartDisabledDates: {
        customPredictor: function(date) {
          const maxDate = new Date().setDate(now.getDate() + 30);
          return date < now || date > maxDate;
        },
      },
      netIncomeFormatting: {
        separator: " ",
      },
    };
  },
  directives: {
    netIncomeFormatting: VNumber,
  },
  computed: {
    ...mapFields([
      "customer_link_reloaded",
      "merchant_id",
      "optenErrorMessge",
      "premium",
      "startDate",
      "limittomb",
      "turnover_band",
      "chosenLimit",
      "chosenTurnover",
      "process",
      "cities",
      "generalInfo.chosenSport",
      "generalInfo.chosenPackage",
      "generalInfo.contractType",
      "generalInfo.isAgent",
      "generalInfo.agentId",
      "generalInfo.propertyType",
      "generalInfo.propertyInhabitated",
      "generalInfo.propertyOutskirts",
      "generalInfo.propertyPhysicalJob",
      "generalInfo.propertyPhysicalJobName",
      "generalInfo.propertyOwnRight",
      "generalInfo.propertyZip",
      "generalInfo.propertyName",
      "generalInfo.selectedPropertyName",
      "MFOLoaded",
      "dm",
      "partnertipus",
      "sportok",
      "limitek",
      "sportNames",
      "insuredSettings.contractedIsInsured",
      "insuredSettings.PhoneNumber",
      "insuredSettings.PhoneNumberArea",
      "companyData",
      "companyData.phtax",
      "companyData.displayedTaxNumber",
      "companyData.companyname",
      "companyData.country",
      "companyData.zip",
      "companyData.city",
      "companyData.streetname",
      "companyData.streettype",
      "companyData.streetno",
      "companyData.streetother",
      "companyData.hrsz",
      "companyData.registrationdate",
      "companyData.companytype",
      "companyData.statusName",
      "companyData.net_income",
      "companyData.profitaftertax",
      "companyData.totalassets",
      "companyData.equity",
      "companyData.yearofdata",
      "companyData.companytypecode",
      "companyData.companytypename",
      "companyData.companystatuscode",
      "companyData.optenCompnayOk",
      "companyData.optenFinanceOk",
      "companyData.financialdatamanualy",
      "brokerData.brokercim",
      "brokerData.brokeremail",
      "brokerData.brokernev",
      "brokerData.brokertel",
      "double_limit",
      "limitType",
      "marks",
      "optenLoading",
      "gfoNames",
      "chosenGFO",
      "ertekesito_koti",
      "send_validationemail_to",
      "GFO",
    ]),
    ...mapFields({
      paymentType: "paymentOptions.type",
      paymentFrequency: "paymentOptions.frequency",
      insuredEmail: "insuredSettings.email",
      insuredEmailVerification: "insuredSettings.emailVerification",
      insuredFirstName: "insuredSettings.firstName",
      insuredLastName: "insuredSettings.lastName",
    }),
    ...mapGetters({
      datas: "getAllState",
    }),
    ...mapActions(["verifyPage", "checkOptenToken", "optenSearch"]),
    propertyNameIsArray: function() {
      return (
        typeof this.propertyName === "object" &&
        this.propertyName &&
        this.propertyName.length > 0
      );
    },
    taxnumInvalidAfterSearch() {
      return this.$store.state.taxnumber_invalid_after_search;
    },
    zipCodes: {
      get() {
        return Object.keys(this.cities);
      },
    },
    correctedTaxNumber: {
      get() {
        return this.phtax.split("-")[0];
      },
    },
    correctedTaxNumberLength: {
      get() {
        return this.phtax.length === 13;
      },
    },
  },
  watch: {
    datas: {
      handler: debounce(function(after, before) {
        if (this.page !== 1 && this.page !== 3) return;

        this.verifyPage();
      }, 3000),
      deep: true,
    },
    // paymentFrequency: function(value) {
    //   if (value == 'havi' && !this.canChooseMonthlyPayment) this.paymentFrequency = 'negyedeves';
    // },
    chosenSport: function(value) {
      this.$store.dispatch("getMarks");
    },
    phtax: function(value) {
      if (value === "") this.$store.commit("setOptenSearcErrorMessage", "");
    },
    // propertyZip: function() {
    //   const zipCodeList = Object.keys(this.cities);
    //   if (
    //     zipCodeList.length === 0 ||
    //     (zipCodeList.length > 0 && !zipCodeList.includes(this.propertyZip))
    //   )
    //     return (this.cityNames = []);

    //   const zipData = this.cities[this.propertyZip];

    //   if (!zipData) return (this.cityNames = []);

    //   this.cityNames =
    //     typeof zipData.telepules === 'string'
    //       ? [zipData.telepules]
    //       : Object.values(zipData.telepules);

    //   if (this.cityNames.length === 1) {
    //     this.selectedPropertyName = this.cityNames[0];
    //   }
    // },
    zip: function() {
      // console.log('zipcodes: ' + this.zipCodes);
      const zipCodeList = Object.keys(this.cities);
      if (
        zipCodeList.length === 0 ||
        (zipCodeList.length > 0 && !zipCodeList.includes(this.zip))
      )
        return (this.cityNames = []);

      const zipData = this.cities[this.zip];

      if (!zipData) return (this.cityNames = []);

      this.cityNames =
        typeof zipData.telepules === "string"
          ? [zipData.telepules]
          : Object.values(zipData.telepules);

      if (this.cityNames.length === 1) {
        this.city = this.cityNames[0];
      }
    },
    isAgent: function() {
      if (this.isAgent === 0)
        this.$store.commit("setGeneralPropertyValues", {
          name: "agentId",
          value: "",
        });
    },
    // chosenSport: function() {
    //   if (this.chosenSport === 'egyeb') {
    //     this.chosenPackage = 'alap';
    //   }
    // },

    allGoodsPrice: function(value) {
      if (!this.clickedAllGoodsPrice) return;

      this.$store.commit("setAllGoodsPriceChangedState", true);
    },

    // limitType: function(value) {
    //   if (value) this.double_limit = 'double_limit';
    //   else {
    //     this.double_limit = 'simple_limit';
    //   }
    //   if (!this.financialdatamanualy) {
    //     this.$store.dispatch('getLimit');
    //     this.$store.dispatch('getPremium');
    //   }
    // },
    chosenTurnover: function(value) {
      this.$store.commit("setChosenLimit", null);
      this.$store.dispatch("getLimit");
    },
    net_income: function(value) {
      // this.$store.commit('setChosenLimit', null);
      this.$store.dispatch("getLimit").then(() => {
        this.$store.dispatch("verifyPage", 1);
      });
    },

    // net_income: debounce(function(after, before) {
    //   this.$store.commit('setChosenLimit', null);
    //   this.$store.dispatch('getLimit').then(() => {
    //     this.$store.dispatch('verifyPage', 1);
    //   });
    // }, 3000),
    chosenLimit: function() {
      this.$store.dispatch("getPremium");
    },
    companyname: function() {
      if (!this.financialdatamanualy) {
        this.getLimits();
      }
    },
  },
  mounted() {
    if (this.paymentFrequency == "havi" && !this.canChooseMonthlyPayment)
      this.paymentFrequency = "negyedeves";
  },
  created() {
    this.$store.dispatch("updateMarks");
  },
  methods: {
    searchTaxNumber: function() {
      this.optenSearchDebounced();
      this.$store.commit("setOptenLoading", true);
    },

    optenSearchDebounced: debounce(function(before, after, immediate) {
      this.$store.commit("setGeneralErrors", []);
      // let searchTaxNumber = this.correctedTaxNumber;
      this.$store.commit("setOptenSearcErrorMessage", "");

      this.$store.commit("resetCompanyData");
      this.$store.commit("setChosenTurnover", null);
      this.$store.dispatch("searchTaxNumber", this.correctedTaxNumber);
      // this.$store.dispatch('optenSearchTest', this.correctedTaxNumber);
      // this.$store.dispatch('getOptenToken');
    }, 3000),

    getLimits() {
      this.limittomb = null;
      this.$store.dispatch("getLimit", 1);
    },

    getPremium() {
      this.$store.dispatch("getPremium", 1);
    },
    showPropertyPhysicalWarning() {
      return this.propertyPhysicalJob === 1;
    },
    getAge(birthDate) {
      var today = new Date();
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    uniqueDeal() {
      this.$store.commit("setProcess", "EGYEDI");
      this.$store.dispatch("verifyPage", 6);
    },
  },
};
</script>

<style lang="scss">
.select2-selection__rendered {
  line-height: 38px !important;
}
.select2-container .select2-selection--single {
  height: 38px !important;
  border-color: #ced4da;
}
.select2-selection__arrow {
  height: 38px !important;
}
.draga {
  background-color: #37bbf0;
  color: white;
}
.olcso {
  background-color: #f5d938;
  color: white;
}
.nincs {
  background-color: #616060;
  color: white;
}
div.card:hover {
  border: #f5d938;
  background-color: #f5d938;
  outline-width: medium;
}
.card-selected {
  background-color: #ece17a !important;
  border: #ece17a !important;
  border-radius: 5px !important;
  box-shadow: 0 0 50px 8px #48abe0;
}
</style>
